<div class="card-body">
  <div>
    <h2 class="d-flex justify-content-center">
      <b style="font-size: 18px"> Create New Company</b>
    </h2>
    <!-- [linear]="true" -->
    <mat-stepper #stepper>
      <mat-step label="Company Information" [completed]="completedFirstStep">
        <!-- <mat-form-field appearance="fill">
          <mat-label>Rep</mat-label>
          <mat-select name="asignarRep" [(ngModel)]="rep_id" required>
            <mat-option *ngFor="let topping of reptoAssagn" [value]="topping.id"
              >{{ topping.name }} {{ topping.surname }}</mat-option
            >
          </mat-select>
        </mat-form-field> -->
        <div class="grid-container">
          <mat-form-field
            [ngClass]="{'has-success': valid.code === 200, 'has-danger': valid.code !== 200 &&  valid.code !== null}"
          >
            <mat-label> CV CODE </mat-label>
            <input
              matInput
              type="text"
              placeholder="{{valid.msg}}"
              name="companyId"
              [(ngModel)]="data.user.companyId"
              (change)="validarCompany()"
              maxlength="10"
              required
            />
            <span class="form-control-feedback">
              <i class="material-icons"
                >{{valid.code === 200 ? 'done' : 'clear'}}</i
              >
            </span>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Company Name</mat-label>
            <input
              matInput
              type="text"
              name="company"
              #company="ngModel"
              [(ngModel)]="data.user.name"
              required
            />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Company Alias</mat-label>
            <input
              matInput
              type="text"
              name="alias"
              #alias="ngModel"
              [(ngModel)]="data.user.alias"
            />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Company Website</mat-label>
            <input
              matInput
              type="text"
              name="website"
              [(ngModel)]="data.user.url"
            />
          </mat-form-field>
        </div>
        <button
          class="gts-btn-primary-outline"
          [disabled]="isDisabledFirstStep"
          (click)="changeStep()"
        >
          <span class="gts-btn-icon-left">east</span
          ><span class="gts-btn-text">Next</span>
        </button>
      </mat-step>
      <mat-step label="Address Information" [completed]="completedSecondStep">
        <mat-form-field>
          <mat-label>Address Line #</mat-label>
          <input
            matInput
            type="text"
            name="address"
            #address="ngModel"
            [(ngModel)]="data.user.address"
            required
          />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Address Line 2 #</mat-label>
          <input
            matInput
            type="text"
            name="address2"
            #address2="ngModel"
            [(ngModel)]="data.user.address2"
          />
        </mat-form-field>
        <div class="grid-container-3">
          <mat-form-field>
            <mat-label>Country</mat-label>
            <mat-select
              name="ctry"
              #ctry="ngModel"
              [(ngModel)]="data.user.country"
              (selectionChange)="getStates(true)"
              required
            >
              <mat-option
                *ngFor="let country of countries"
                [value]="country.name"
              >
                {{ formatName(country.name)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="states.length === 0">
            <mat-label class="bmd-label-floating"
              >State
              <i
                *ngIf="loadingStates"
                class="fa fa-circle-o-notch fa-spin fa-fw"
              ></i
            ></mat-label>
            <input
              matInput
              type="text"
              name="colonia"
              #colonia="ngModel"
              [(ngModel)]="data.user.colonia"
              [disabled]="loadingStates"
              required
            />
          </mat-form-field>
          <mat-form-field *ngIf="states.length > 0">
            <mat-label>State</mat-label>
            <mat-select
              name="colonia"
              #colonia="ngModel"
              [(ngModel)]="data.user.colonia"
              [disabled]="loadingStates"
              required
            >
              <mat-option *ngFor="let state of states" [value]="state.abbr">
                {{state.abbr}} - {{ state.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>City</mat-label>
            <input
              matInput
              type="text"
              name="city"
              #city="ngModel"
              [(ngModel)]="data.user.city"
              required
            />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Zip Code</mat-label>
            <input
              matInput
              type="text"
              name="zipCode"
              #zipCode="ngModel"
              [(ngModel)]="data.user.zipCode"
              required
            />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Work Phone</mat-label>
            <input
              type="text"
              name="phone"
              #phone="ngModel"
              [(ngModel)]="data.user.phone"
              matInput
              required
            />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Mobile Phone</mat-label>
            <input
              type="text"
              matInput
              name="mobilePhone"
              #mobilePhone="ngModel"
              [(ngModel)]="data.user.mobilePhone"
            />
          </mat-form-field>
        </div>
        <div class="d-flex mt-4">
          <button
            class="gts-btn-primary-outline mr-2"
            matRipple
            matStepperPrevious
          >
            <span class="gts-btn-icon-left">west</span
            ><span class="gts-btn-text">Previous</span>
          </button>
          <button
            class="gts-btn-primary-outline"
            matRipple
            matStepperNext
            [disabled]="isDisabledSecondStep"
          >
            <span class="gts-btn-icon-left">east</span
            ><span class="gts-btn-text">Next</span>
          </button>
        </div>
      </mat-step>
      <mat-step label="Settings" [completed]="completedThirdStep">
        <mat-checkbox name="check3rd" [(ngModel)]="data.user.enablePartyPickup">
          Enable 3rd Party Pickup
        </mat-checkbox>

        <div class="grid-container-3">
          <mat-form-field>
            <mat-label>Default Condition</mat-label>
            <mat-select
              name="condition"
              #condition="ngModel"
              [(ngModel)]="data.user.conditionId"
              required
            >
              <mat-option
                *ngFor="let condition of conditions"
                [value]="condition.id"
              >
                {{ condition.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Default Currency</mat-label>
            <mat-select
              name="currency"
              #currency="ngModel"
              [(ngModel)]="data.user.currenciesId"
              required
            >
              <mat-option
                *ngFor="let currency of currencies"
                [value]="currency.id"
              >
                {{ currency.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Industry Type</mat-label>
            <mat-select
              #industryType="ngModel"
              name="industryType"
              [(ngModel)]="data.user.industryType"
              placeholder="Industry Type"
              required
            >
              <mat-option value="null"> Please select an option </mat-option>
              <mat-option *ngFor="let type of industryTypes" [value]="type.id">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Default Purchasing Terms</mat-label>
            <mat-select
              name="purchasingTerms"
              #purchasingTerms="ngModel"
              [(ngModel)]="data.user.purchasingtermsId"
              required
            >
              <mat-option
                *ngFor="let term of purchassingTerms"
                [value]="term.id"
              >
                {{ term.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Default Selling Terms</mat-label>
            <mat-select
              name="term"
              #term="ngModel"
              [(ngModel)]="data.user.termsId"
              required
            >
              <mat-option *ngFor="let term of terms" [value]="term.id">
                {{ term.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <mat-form-field appearance="fill">
            <mat-label>Default Currency</mat-label>
            <mat-select
              name="currency"
              #currency="ngModel"
              matNativeControl
              [(ngModel)]="data.user.currenciesId"
              placeholder="Default Currency"
            >
              <mat-option
                *ngFor="let currency of currencies"
                [value]="currency.id"
              >
                {{ currency.name }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
          <mat-form-field appearance="fill">
            <mat-label>Default Erasure Method</mat-label>

            <mat-select
              name="passDataErasure1"
              #passDataErasure1="ngModel"
              [(ngModel)]="data.user.passDataErasure1"
              placeholder="Default Erasure Method"
              required
            >
              <mat-option value="null"> Please select an option </mat-option>
              <mat-option
                *ngFor="let item of erasureMethods"
                [value]="item.name"
              >
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label> Purchasing Credit Limit</mat-label>
            <input
              matInput
              name="purchasingCreditLimit"
              [(ngModel)]="data.user.purchasingCreditLimit"
              type="number"
              min="0.00"
              placeholder="0.00"
            />
          </mat-form-field>
          <mat-form-field>
            <mat-label> Selling Credit Limit</mat-label>
            <input
              matInput
              name="sellingCreditLimit"
              [(ngModel)]="data.user.creditLimit"
              type="number"
              min="0.00"
              placeholder="0.00"
            />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Outstanding Invoice Day Limit</mat-label>
            <input
              matInput
              type="number"
              placeholder="0"
              min="0.00"
              name="outstandingInvoiceDayLimit"
              [(ngModel)]="data.user.outstandingInvoiceDayLimit"
            />
          </mat-form-field>
        </div>
        <div class="d-flex mt-4">
          <button
            class="gts-btn-primary-outline mr-2"
            matRipple
            matStepperPrevious
          >
            <span class="gts-btn-icon-left">west</span
            ><span class="gts-btn-text">Previous</span>
          </button>
          <button
            [disabled]="valid.code !== 200 || 
            !data.user.passDataErasure1    || 
            !data.user.termsId ||
            !data.user.purchasingtermsId ||
            !data.user.industryType ||
            !data.user.currenciesId ||
            !data.user.conditionId 
            "
            class="gts-btn-primary"
            [mat-dialog-close]="data.user"
            cdkFocusInitial
          >
            <span class="gts-btn-text"> Save </span>
          </button>

          <!-- <button
            class="gts-btn-primary-outline"
            matRipple
            matStepperNext
            [disabled]="isDisabledThirdStep"
          >
            <span class="gts-btn-icon-left">east</span
            ><span class="gts-btn-text">Next</span>
          </button> -->
        </div>
      </mat-step>
      <!-- <mat-step label="Taxes">
        <label style="cursor: pointer; margin-top: 10px">
          <mat-checkbox
            name="weightbalance"
            color="primary"
            (change)="changeTaxExempt($event)"
            [checked]="user.taxExempt !== 0"
          ></mat-checkbox>
          &nbsp; Tax Exempt
        </label>
        <mat-form-field *ngIf="user.taxExempt !== 0">
          <mat-label>Sales Tax Number</mat-label>
          <input
            matInput
            type="text"
            name="salesTaxNumber"
            [(ngModel)]="user.salesTaxNumber"
          />
        </mat-form-field>

        <app-multi-files
          [idfather]="user.id"
          title="Resale Tax Certificate:"
          [type]="'ResaleTaxCertificateCompany'"
        ></app-multi-files>
      </mat-step> -->
    </mat-stepper>
  </div>
</div>
